import { useState } from "react";
import useResponsive from "../../../components/hooks/useResponsive";
import Modal from "@mui/material/Modal";
import { Box, Tooltip, Typography, Fade, Card } from "@mui/material";
import { COLORS } from "../../../ui/Theme";
import { IoCopyOutline } from "react-icons/io5";
import { useOrdersContext } from "../../../context/subscription/orders/OrdersContext";
import { paymentDetails } from "./data";

const ConfirmOrders = () => {
    const { plansData, showConfirmationForm, setShowConfirmationForm } = useOrdersContext();
    const { isSm } = useResponsive();
    const [copied, setCopied] = useState(null);

    const handleCopy = async (value) => {
        await navigator.clipboard.writeText(value);
        setCopied(value);
        setTimeout(() => setCopied(null), 1500);
    };

    return (
        <Modal
            open={showConfirmationForm}
            onClose={() => setShowConfirmationForm(false)}
            closeAfterTransition
        >
            <Fade in={showConfirmationForm}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "linear-gradient(135deg, #f8fafc 0%, #e8eef5 100%)",
                        borderRadius: "16px",
                        boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
                        p: 4,
                        maxWidth: "95%",
                        width: 500,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 3,
                    }}
                >
                    {/* عنوان */}
                    <Typography
                        sx={{
                            fontWeight: 700,
                            textAlign: "center",
                            mb: 1,
                            fontSize: "18px",
                        }}
                    >
                        تایید نهایی سفارش
                    </Typography>

                    <Box
                        sx={{
                            borderRadius: "14px",
                            width: "100%",
                            backdropFilter: "blur(12px)",
                            background: "rgba(255, 255, 255, 0.7)",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                            overflow: "hidden",
                        }}
                    >
                        {[
                            { label: "بانک:", value: "بانک شهر" },
                            { label: "به نام:", value: "آرمان سرمایه همراه" },
                            {
                                label: "مبلغ قابل پرداخت:",
                                value: `${plansData?.price?.toLocaleString("fa-IR") ?? "-"} تومان`,
                            },
                        ].map((item) => (
                            <Box
                                key={item.label}
                                sx={{
                                    p: "10px 16px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.04)",

                                    "&:last-child": { borderBottom: "none" },
                                }}
                            >
                                <Typography sx={{ fontSize: "13px", fontWeight: 500, color: COLORS.GRAY }}>
                                    {item.label}
                                </Typography>
                                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: COLORS.BLUE }}>
                                    {item.value}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
                        {paymentDetails.map((item) => (
                            <Tooltip
                                key={item.label}
                                title="کپی شد"
                                open={copied === item.value}
                                disableHoverListener
                            >
                                <Box
                                    onClick={() => handleCopy(item.value)}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        p: "10px 14px",
                                        borderRadius: "12px",
                                        backgroundColor: COLORS.WHITE,
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                                        cursor: "pointer",
                                        transition: "all 0.25s ease",
                                        "&:hover": {
                                            borderColor: COLORS.BLUE,
                                            backgroundColor: "#f0f7ff",
                                            transform: "translateY(-2px)",
                                        },
                                        ...(copied === item.value && {
                                            backgroundColor: "#e6f4ff",
                                            borderColor: COLORS.BLUE,
                                        }),
                                    }}
                                >
                                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                                        <Typography sx={{ fontSize: "13px", color: COLORS.GRAY }}>
                                            {item.label}
                                        </Typography>
                                        <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                                            {item.value}
                                        </Typography>
                                    </Box>

                                    <IoCopyOutline
                                        size={18}
                                        color={copied === item.value ? COLORS.BLUE : COLORS.GRAY}
                                    />
                                </Box>
                            </Tooltip>
                        ))}
                    </Box>

                    <Card
                        sx={{
                            fontSize: 12,
                            fontWeight: 500,
                            lineHeight: 1.8,
                            background: COLORS.SOFTRED,
                            textAlign: "center",
                            color: COLORS.RED
                        }}
                    >
                        لطفا پس از پرداخت، عکس فیش واریزی خود را در قسمت تیکت ارسال فرمایید.
                    </Card>

                    <button
                        className="btn btn-blue"
                        onClick={() => setShowConfirmationForm(false)}

                    >
                        متوجه شدم
                    </button>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ConfirmOrders;
